module.exports = __webpack_public_path__ + "static/media/bkash-web-icon.d5bade40.svg";